class CurrencyListService {
    constructor() {
        this.getCurrenciesList = () => {
            return [
                'UAH',
                'USD',
                'EUR',
                'GBP'
            ];
        };
    }
}
commons.service('currencyListService', CurrencyListService);